import { Common } from '@stockbit/ui';
import { Autocomplete } from './styled';
import { Relative } from '../../OnBoardingLayout/styled';

const { Input, Iconmoon } = Common;

function Search({ options, onSelect, onSearch, onChange, value }) {
  return (
    <Relative>
      <Autocomplete
        options={options}
        width="100%"
        onSelect={onSelect}
        onSearch={onSearch}
        mb="8px"
        getPopupContainer={(trigger) => trigger.parentElement}
        value={value}
        onChange={onChange}
      >
        <Input
          prefix={<Iconmoon className="icon-avatar_search" />}
          placeholder="Type here to add people ..."
          height="36px"
          width="100%"
        />
      </Autocomplete>
    </Relative>
  );
}

export default Search;
